import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SSEEventData, SSEEventType } from 'constants/sse';
import { RootState } from 'store';

import useSSEConnection from './useSSEConnection';



const useSSEEvent = (eventType: SSEEventType) => {
  const [data, setData] = useState<SSEEventData | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const { isConnected, error: connectionError } = useSSEConnection();
  const sseData = useSelector((state: RootState) => state.sse.data) as SSEEventData;

  useEffect(() => {
    if (connectionError) {
      setError(new Error(connectionError));
      return;
    }

    if (isConnected && sseData?.eventType === eventType) {
      setData(sseData);
      setError(null);
    }
  }, [sseData, eventType, isConnected, connectionError]);

  return { data, error };
};

export default useSSEEvent; 